// import packages
import React from "react";

// import hoc
import { withErrorBoundary } from "lib/hoc";

const XhawiTerms = () => {
  return (
    <div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <title>Xhawi Marketplace Terms and Conditions</title>
      <style>
        body {
          margin: 0;
          font-family: "Segoe UI", Arial, sans-serif;
          line-height: 1.6;
          color: #111;
          background: #fafafa;
          display: flex;
          flex-direction: column;
          min-height: 100vh;
        }
    
        .content {
          flex: 1;
          padding: 40px 50px;
          max-width: 900px;
          margin: auto;
        }
    
        h1 {
          font-size: 32px;
          margin-bottom: 10px;
          color: #000;
          border-bottom: 4px solid #b5f75b;
          padding-bottom: 8px;
        }
    
        h2 {
          margin-top: 30px;
          font-size: 22px;
          color: #000;
          padding-top: 3px;
          padding-bottom: 3px;
        }
    
        h3 {
          margin-top: 15px;
          font-size: 17px;
          color: #111;
          font-weight: bold;
          margin-left: 15px;
        }
    
        p, li {
          font-size: 15px;
          color: #222;
        }
    
        ul {
          margin: 10px 0 20px 40px;
        }
    
        strong {
          color: #000;
        }
    
        .section {
          margin-bottom: 25px;
          position: relative;
        }
    
        /* Smooth scrolling */
        html {
          scroll-behavior: smooth;
        }
    
        /* Highlight final note */
        .final-note {
          margin-top: 35px;
          padding: 15px;
          background: #b5f75b;
          color: #000;
          font-weight: bold;
          border-radius: 4px;
        }
    
        /* Footer */
        footer {
          background: #b5f75b;
          color: #000;
          text-align: center;
          padding: 15px;
          font-size: 14px;
          margin-top: 40px;
        }
    
        /* Responsive adjustments */
        @media (max-width: 768px) {
          .content {
            padding: 20px;
          }
          h1 {
            font-size: 26px;
          }
          h2 {
            font-size: 20px;
          }
          h3 {
            font-size: 16px;
            margin-left: 10px;
          }
          p, li {
            font-size: 14px;
          }
          ul {
            margin-left: 25px;
          }
        }
    
        @media (max-width: 480px) {
          .content {
            padding: 15px;
          }
          h1 {
            font-size: 22px;
          }
          h2 {
            font-size: 18px;
          }
          h3 {
            font-size: 15px;
            margin-left: 8px;
          }
          p, li {
            font-size: 13px;
          }
          ul {
            margin-left: 20px;
          }
          footer {
            font-size: 13px;
            padding: 12px;
          }
        }
      </style>
    </head>
    <body>
    
      <div class="content">
        <h1>Terms & Conditions</h1>
        <h2>Xhawi Marketplace Terms and Conditions</h2>
        <p>
          These Terms and Conditions (the “Policy”) are binding upon all users of the Xhawi marketplace 
          (“Xhawi” together with “we,” “us,” and “our”). This Policy forms a legally binding contract between 
          each user (“you” or “consumer”) of the Services and Xhawi. By accessing or using the Services, you 
          agree to the terms outlined in this Policy, along with the Privacy Policy and any other policies 
          published by Xhawi.
        </p>
    
        <div id="acceptance" class="section">
          <h2>1. Acceptance of Policy</h2>
          <p>
            By using the Xhawi Services, including browsing the Xhawi website, mobile apps, or other services, 
            you acknowledge and agree to the terms of this Policy. Continued use of the Services constitutes 
            acceptance of these terms and any amendments published by Xhawi from time to time.
          </p>
        </div>
    
        <div id="warranty" class="section">
          <h2>2. Product Warranty and Liability</h2>
          <h3>a. Independent Sellers</h3>
          <ul>
            <li>Xhawi is a platform that connects buyers and independent sellers...</li>
            <li>Xhawi does not produce, manufacture, or inspect items unless explicitly stated in a seller agreement.</li>
            <li>Xhawi makes no warranty regarding quality, accuracy, or fitness for a particular purpose of products sold.</li>
          </ul>
          <h3>b. Warranty Coverage</h3>
          <ul>
            <li>Products are warranted for manufacturing defects only...</li>
            <li><strong>Replacement Policy:</strong> Defective items may be replaced within 15 days.</li>
            <li><strong>Warranty Period:</strong> One year unless otherwise stated.</li>
            <li>Customers must inspect products at delivery and report concerns immediately.</li>
          </ul>
        </div>
    
        <div id="accuracy" class="section">
          <h2>3. Content Accuracy and User Interactions</h2>
          <h3>a. Product Information</h3>
          <p>Xhawi does not guarantee the accuracy, IP compliance, or legality of product descriptions provided by sellers.</p>
          <h3>b. Interactions with Sellers</h3>
          <p>Consumers interact with sellers at their own risk. Xhawi is not liable for user interactions or transactions.</p>
        </div>
    
        <div id="returns" class="section">
          <h2>4. Returns, Exchanges, and Refunds</h2>
          <ul>
            <li>Items must be in re-saleable condition with original packaging and accessories.</li>
            <li>Xhawi may refuse returns or exchanges at its discretion.</li>
            <li>Photo ID may be required.</li>
            <li>Refunds are processed only after seller inspection of returned goods.</li>
          </ul>
        </div>
    
        <div id="links" class="section">
          <h2>5. Third-Party Links</h2>
          <p>Xhawi is not responsible for third-party sites or services linked from its platform. Access is at user’s risk.</p>
        </div>
    
        <div id="warranties" class="section">
          <h2>6. No Warranties</h2>
          <p>Services are provided “as-is” with no warranties of title, merchantability, fitness, or non-infringement.</p>
        </div>
    
        <div id="availability" class="section">
          <h2>7. Service Availability</h2>
          <p>Xhawi does not guarantee uninterrupted access, security, or error-free operation of Services.</p>
        </div>
    
        <div id="responsibility" class="section">
          <h2>8. User Responsibility</h2>
          <p>Users bear responsibility for all costs of accessing the marketplace (devices, software, internet, etc.).</p>
        </div>
    
        <div id="liability" class="section">
          <h2>9. Limitation of Liability</h2>
          <p>Xhawi and its agents are not liable for:</p>
          <ul>
            <li>Loss of profit, revenue, or data.</li>
            <li>Indirect, special, incidental, or punitive damages, even if advised.</li>
          </ul>
        </div>
    
        <div id="indemnity" class="section">
          <h2>10. Indemnity</h2>
          <p>Consumers agree to indemnify Xhawi for claims, losses, or damages resulting from:</p>
          <ul>
            <li>Breach of this Policy.</li>
            <li>Misuse of the platform.</li>
            <li>Violations of third-party rights.</li>
          </ul>
        </div>
    
        <div id="law" class="section">
          <h2>11. Governing Law and Disputes</h2>
          <p>Policy governed by laws of the Sultanate of Oman. Disputes resolved exclusively in its courts.</p>
        </div>
    
        <div id="severability" class="section">
          <h2>12. Severability</h2>
          <p>If any provision is unenforceable, remaining provisions remain valid.</p>
        </div>
    
        <div id="waiver" class="section">
          <h2>13. Non-Waiver</h2>
          <p>Xhawi’s failure to enforce a provision does not waive its rights.</p>
        </div>
    
        <div id="assignment" class="section">
          <h2>14. Assignment</h2>
          <p>Xhawi may assign rights and obligations under this Policy to third parties.</p>
        </div>
    
        <div id="amendments" class="section">
          <h2>15. Amendments</h2>
          <p>Xhawi may revise this Policy at any time. Continued use means acceptance of changes.</p>
        </div>
    
        <div class="final-note">
          By using Xhawi, you agree to these Terms and Conditions. For inquiries, contact us at care@xhawi.com.
        </div>
      </div>
    </body>
    </html>
    ` }} />
  );
};

export default withErrorBoundary(XhawiTerms);
